export const FREQUENCY = [
	{ id: 0, name: '7D', value: 7 },
	{ id: 1, name: '30D', value: 30 },
	{ id: 2, name: 'All-time', value: 10000 },
];
